import {createContext, SetStateAction, useContext} from "react";

export interface DeXuatContextProps {
  dsYeuCau: any;
  setDsYeuCau: SetStateAction<any>;
  detailPhieuYeuCau: any;
  setDetailPhieuYeuCau: SetStateAction<any>;

}

const initialContext = {
  dsYeuCau: [],
  setDsYeuCau: () => { },
  detailPhieuYeuCau: [],
  setDetailPhieuYeuCau: () => { },
}

export const DeXuatContext = createContext<DeXuatContextProps>(initialContext);

export const useDeXuatContext = () => useContext(DeXuatContext);

export const DeXuatProvider = DeXuatContext.Provider;
